<template>
    <!--咨询记录公用弹窗-->
    <div>
        <el-dialog :visible.sync="visible" v-if="visible" v-loading="loading" element-loading-text="提交中……"
                   :close-on-click-modal="false" :before-close="close" width="760px">
            <div slot="title">
                <z-title :title="type+'咨询记录'"></z-title>
            </div>
            <el-form :model="dataForm" :rules="rules" ref="ruleForm" class="rulefrom" size="medium">
                <el-form-item label="姓 名" prop="customName" label-width="90px" :show-message="false">
                    <el-input class="w-200" maxlength="20" v-model="dataForm.customName"
                              placeholder="请输入来访用户姓名"></el-input>
                </el-form-item>
                <div class="flex-n">
                    <el-form-item label="手机号码" prop="phone" label-width="90px">
                        <el-input class="w-200" type="number" maxlength="11" v-model="dataForm.phone"
                                  placeholder="请输入来访用户手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="微信号" prop="wechatNo" label-width="90px">
                        <el-input maxlength="64" class="w-200" v-model="dataForm.wechatNo"
                                  placeholder="请输入微信号"></el-input>
                    </el-form-item>
                </div>

                <div class="flex-n">
                    <el-form-item label="意向日期" prop="wantDate" label-width="90px" :show-message="false">
                        <el-date-picker
                                class="w-200"
                                v-model="dataForm.wantDate"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="请选择意向日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="意向数量" prop="userCount" label-width="90px">
                        <el-input class="w-200" placeholder="请输入意向数量" v-model="dataForm.userCount"
                                  v-number="{max:9999,min:1}">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="flex-n" v-if="dataForm.wantDate">
                    <el-form-item label="时间段" prop="wantBeginTime" label-width="90px">
                        <el-time-select
                                value-format="HH:mm" format="HH:mm"
                                class="w-120"
                                placeholder="起始时间"
                                v-model="dataForm.wantBeginTime"
                                @change="validatorBeginTime"
                                :inline-message="true"
                                :picker-options="{ start: '07:00',
    step: '00:30',
    end: '24:00',
     maxTime: dataForm.wantEndTime||'24:00'}"
                              >
                        </el-time-select>
                    </el-form-item>
                    <div class="plr-10 mt-10">-</div>
                    <el-form-item label="" prop="wantEndTime" label-width="0">
                        <el-time-select
                                class="w-120 mr-10"
                                placeholder="结束时间"
                                value-format="HH:mm" format="HH:mm"
                                @change="validatorEndTime"
                                v-model="dataForm.wantEndTime"
                                :picker-options="{ start: '07:30',
    step: '00:30',
    end: '24:00',
    minTime: dataForm.wantBeginTime||'07:00'}">
                        </el-time-select>
                    </el-form-item>
                    <el-button type="primary" round class="ele-btn-small" style="margin-top: 4px"
                               v-for="item,index in timeList"
                               @click="chooseTime(item.start,item.end)">
                        {{item.start}}~{{item.end}}
                    </el-button>
                </div>
                <el-form-item label="意向场地" prop="wantHouse" label-width="90px" :show-message="false">
                    <want-house size="medium" multiple style="width: 100%" @change="changeHouseInfo"
                                v-model="dataForm.wantHouse" placeholder="请选择意向场地"></want-house>
                </el-form-item>
                <div class="flex-n ">
                    <el-form-item label="意向度" prop="wantLevel" label-width="90px" :show-message="false">
                        <want-level class="w-200" v-model="dataForm.wantLevel" placeholder="请选择意向度"></want-level>
                    </el-form-item>

                    <div class="flex-n fac">
                        <el-form-item prop="budgetStart" label="预算范围" label-width="90px">
                            <el-input placeholder="￥" class="w-100" v-model="dataForm.budgetStart"
                                      v-number="{precision:2}">
                            </el-input>
                        </el-form-item>
                        <div style="padding: 0 10px">-</div>
                        <el-form-item prop="budgetEnd" label-width="0">
                            <el-input placeholder="￥" class="w-100" v-model="dataForm.budgetEnd"
                                      v-number="{precision:2}">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="flex-n">
                <el-form-item label="来 源" prop="customFrom" label-width="90px" :show-message="false">
                    <user-from class="w-200" type="object" v-model="dataForm.customFrom"
                               placeholder="请选择来源"></user-from>
                </el-form-item>

                <el-form-item label="提醒日期" prop="alertDate" :show-message="false" label-width="90px"
                              :rules="checkedAlert?[]:[{required: true,validator: validatealertdate,trigger: 'change'}]">
                    <el-date-picker
                            class="w-200"
                            v-model="dataForm.alertDate"
                            :picker-options="pickerOptions2"
                            value-format="yyyy-MM-dd"
                            :disabled="checkedAlert"
                            type="date"
                            placeholder="请选择提醒日期">
                    </el-date-picker>
                    <el-checkbox class="ml-10" v-model="checkedAlert">不提醒</el-checkbox>
                </el-form-item>
                </div>
                <el-form-item label="备 注" prop="remark" label-width="90px">
                    <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                              maxlength="512"></el-input>
                </el-form-item>
                <el-form-item class="mt-10 flex-n fje">
                    <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
                    <el-button @click="close">取 消</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import WantHouse from "../../components/data/wantHouse";
    import WantLevel from "../../components/data/wantLevel";
    import UserFrom from "../../components/data/userFrom";

    export default {
        components: {
            UserFrom,
            WantLevel,
            WantHouse,
            ZTitle
        },
        name: "consultation",
        props: {
            type: String,
            visible: Boolean,
            data: Object,
            id: String,
        },
        model: {
            prop: 'data',
            event: 'input'
        },
        watch: {
            checkedAlert(newval, oldval) {
                if (this.checkedAlert) {
                    this.$set(this.dataForm, 'alertDate', null);
                }
            },
            visible(newval, oldval) {
                if (!newval) {
                    this.$refs.ruleForm.resetFields();
                    this.$emit('input', {})
                    console.log(this.data)
                } else {
                    if (this.type != '新增') {
                        this.dataForm = this.data;
                        var data = this.data;
                        var customFrom = {
                            id: data.customFromId,
                            customFrom: data.customFromName
                        };

                        this.wantHouse = this.dataForm.wantHouse;
                        var wantHouse = [];
                        for (var i in this.wantHouse) {
                            wantHouse.push(this.wantHouse[i].id)
                        }
                        // this.dataForm.customFrom={
                        //     id:data.customFromId,
                        //     customFrom:data.customFromName
                        // }
                        this.$set(this.dataForm, 'customFrom', customFrom);
                        this.$set(this.dataForm, 'wantHouse', wantHouse)
                        if (this.dataForm.alertDate == null) {
                            this.checkedAlert = true;
                        }
                    } else {
                        this.dataForm = {};
                        this.$set(this.dataForm, 'phone', '')
                    }
                    this.getorderalertTime();
                    this.getTimeRange();
                }
            },
        },
        data() {
            var validatetel = (rule, value, callback) => {
                console.log(value)
                if (value && value != '' && value.length != 11) {
                    return callback(new Error('请输入11位的有效手机号码'));
                }
                return callback();
            };
            var validatebudgetEnd = (rule, value, callback) => {
                console.log(value, this.dataForm.budgetStart)
                if (value == '') {
                    if (this.dataForm.budgetStart == '') {
                        this.$refs['ruleForm'].validateField('budgetStart')
                    } else {
                        return callback(new Error(' '));
                    }
                } else {
                    if (this.dataForm.budgetStart == '') {
                        this.$refs['ruleForm'].validateField('budgetStart')
                    } else {
                        if (Number(value) < Number(this.dataForm.budgetStart))
                            return callback(new Error('结束价格必须大于等于起始价格 '));
                    }
                }
                return callback();
            };
            var validatebudgetStart = (rule, value, callback) => {
                if (value == '') {
                    if (this.dataForm.budgetEnd != '') {
                        return callback(new Error(' '));
                    }
                } else {
                    this.$refs['ruleForm'].validateField('budgetEnd');
                }
                return callback();
            };
            var validatewantdate = (rule, value, callback) => {
                //先判断checkedAlert ,true 为空
                if (this.checkedAlert) {
                    this.$set(this.dataForm, 'alertDate', null)
                }
                else {
                    //计算提醒日期
                    var time = new Date(new Date(this.$TM.getDayArea().date).getTime() + this.askAlertDaysAfter * 24 * 60 * 60 * 1000)
                    //默认提醒日期小于当前意向日期
                    console.log(time.getTime(), new Date(this.dataForm.wantDate).getTime(), time.getTime() <= new Date(this.dataForm.wantDate).getTime())
                    if (time.getTime() <= new Date(this.dataForm.wantDate).getTime()) {
                        //提醒日期是否大于意向日期，大于置空
                        if (new Date(this.dataForm.alertDate).getTime() > new Date(this.dataForm.wantDate).getTime()) {
                            this.$set(this.dataForm, 'alertDate', null)
                        } else {
                            //提醒日期为空
                            if (this.dataForm.alertDate == null) {
                                console.log('进来了')
                                this.$set(this.dataForm, 'alertDate', time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate())
                            }
                        }
                    } else {
                        //提醒日期是否大于意向日期，大于置空
                        if (new Date(this.dataForm.alertDate).getTime() > new Date(this.dataForm.wantDate).getTime()) {
                            this.$set(this.dataForm, 'alertDate', null)
                        }
                    }
                }

                return callback();
            };
            var validateuserCount = (rule, value, callback) => {
                if (value == ''||!value) {
                    return callback(new Error(' '));
                }
                if (Number(value) == 0) {
                    this.$set(this.dataForm, 'userCount', 1)
                    // return callback(new Error('意向人数不能小于0'));
                }
                return callback();
            };
            var checkBeginTime = (rule, value, callback) => {
                console.log(this.dataForm.wantEndTime,value)
                if (this.dataForm.wantEndTime&&(!value||value == '')) {
                    return callback(new Error(' '));
                }
                return callback();
            };
            var checkEndTime = (rule, value, callback) => {
                console.log(this.dataForm.wantBeginTime,value)
                if (this.dataForm.wantBeginTime&&(!value||value == '')) {
                    return callback(new Error(' '));
                }
                return callback();
            };
            return {
                loading: false,
                wantHouse: [],
                //时间段
                timeList: [],
                rules: {
                    customName: [{required: true, trigger: 'blur'}],
                    phone: [{validator: validatetel, trigger: 'change'}],
                    userCount: [{required: true, validator: validateuserCount, trigger: 'blur'}],
                    budgetEnd: [{validator: validatebudgetEnd, trigger: ['change', 'blur']}],
                    budgetStart: [{validator: validatebudgetStart, trigger: ['change', 'blur']}],
                    wantDate: [{required: true, trigger: 'change'},
                        {validator: validatewantdate, trigger: 'change'}],
                    customFrom: [{required: true, message: '请选择来源', trigger: 'change'}],
                    wantLevel: [{required: true, message: '请选择意向程度', trigger: 'blur'}],
                    wantHouse: [{type: 'array', required: true, message: '请选择意向场地', trigger: ['change', 'blur']}],
                    wantEndTime: [{ validator: checkEndTime, trigger: ['change','blur']}],
                    wantBeginTime: [{ validator: checkBeginTime, trigger: ['change','blur']}],
                },
                checkedAlert: false,
                askAlertDaysAfter: 0,
                dataForm: {
                    customName: '',
                    phone: '',
                    wechatNo: '',
                    userCount: '',
                    wantDate: null,
                    alertDate: null,
                    wantBeginTime:'',
                    wantEndTime:'',
                    customFrom: {
                        id: '',
                        customFrom: ''
                    },
                    budgetStart: '',
                    budgetEnd: '',
                    wantLevel: '',
                    wantHouse: [],
                    remark: ''
                },
            }
        },
        mounted() {
        },
        computed: {
            pickerOptions() {
                return {
                    disabledDate: time => (time.getTime() < Date.now() - 24 * 60 * 60 * 1000)
                }
                //只能选今天之后的
            },
            pickerOptions2() {
                return {
                    disabledDate: time => (this.dataForm.wantDate == null ? (time.getTime() < Date.now() - 24 * 60 * 60 * 1000) : (time.getTime() > new Date(this.dataForm.wantDate).getTime() || time.getTime() < Date.now() - 24 * 60 * 60 * 1000))
                }
            },
        },
        methods: {
            validatorBeginTime() {
                this.$refs['ruleForm'].validateField('wantEndTime');
            },
            validatorEndTime() {
                this.$refs['ruleForm'].validateField('wantBeginTime');
            },
            //获取时间段
            getTimeRange() {
                this.$axios.post('/orderTag/orderTagCode', {
                    "storeId": this.$root.getStorage('storeId')
                }).then(res => {
                    // console.log('时间段', res.data)
                    var timeList = [];
                    res.data.list.forEach((item, index) => {
                        let a = item.orderTagName.split('--')
                        timeList.push({start: a[0], end: a[1]})
                    })
                    this.timeList = timeList;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            chooseTime(start, end) {
                    this.$set(this.dataForm, 'wantBeginTime', start);
                    this.$set(this.dataForm, 'wantEndTime', end);
            },
            changeHouseInfo(data) {
                this.wantHouse = data;
            },
            validatealertdate(rule, value, callback) {
                if (value == null) {
                    return callback(new Error(' '));
                }
                return callback();
            },
            getorderalertTime() {
                this.$axios.get('/config/baseByStoreId/' + this.$root.getStorage('storeId')).then(res => {
                    console.log('咨询提醒时间间隔', res)
                    this.askAlertDaysAfter = Number(res.data.askAlertDaysAfter || 0);
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //添加提交
            addSubmit() {
                var dataForm = this.dataForm;
                var wantHouse = [];
                for (var i in this.wantHouse) {
                    wantHouse.push({'houseId': this.wantHouse[i].id, 'houseName': this.wantHouse[i].houseName})
                }
                this.$axios.post('/preUserAsk/saveAsk', {
                    storeId: this.$root.getStorage('storeId'),
                    customName: dataForm.customName,//客户名称
                    phone: dataForm.phone,//手机号
                    wechatNo: dataForm.wechatNo,//微信号
                    userCount: dataForm.userCount,//意向人数
                    wantDate: dataForm.wantDate,//意向日期
                    alertDate: this.checkedAlert ? null : dataForm.alertDate,//提醒日期
                    wantBeginTime:dataForm.wantBeginTime,
                    wantEndTime:dataForm.wantEndTime,
                    customFromId: dataForm.customFrom.id,//用户来源
                    customFromName: dataForm.customFrom.customFrom,
                    budgetStart: dataForm.budgetStart,//预期起
                    budgetEnd: dataForm.budgetEnd,//预期止
                    wantLevel: dataForm.wantLevel,//意向程度
                    wantHouse: wantHouse,//意向场地
                    remark: dataForm.remark,//备注
                }).then(res => {
                    this.loading = false;
                    this.$message.success(this.type + '咨询成功！');
                    this.$emit('refresh');
                    this.$emit('update:visible', false)
                }).catch(err => {
                    this.loading = false;
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit() {
                var dataForm = this.dataForm;
                var wantHouse = [];
                for (var i in this.wantHouse) {
                    wantHouse.push({'houseId': this.wantHouse[i].id, 'houseName': this.wantHouse[i].houseName})
                }
                this.$set(dataForm, 'alertDate', this.checkedAlert ? null : dataForm.alertDate)
                console.log('alertDate', dataForm.alertDate)
                this.$axios.post('/preUserAsk/updateAsk', {
                    storeId: this.$root.getStorage('storeId'),
                    id: this.id,
                    customName: dataForm.customName,//客户名称
                    phone: dataForm.phone,//手机号
                    wechatNo: dataForm.wechatNo,//微信号
                    userCount: dataForm.userCount,//意向人数
                    wantDate: dataForm.wantDate,//意向日期
                    alertDate: this.checkedAlert ? null : dataForm.alertDate,//提醒日期
                    wantBeginTime:dataForm.wantBeginTime,
                    wantEndTime:dataForm.wantEndTime,
                    customFromId: dataForm.customFrom.id,//用户来源
                    customFromName: dataForm.customFrom.customFrom,
                    budgetStart: dataForm.budgetStart,//预期起
                    budgetEnd: dataForm.budgetEnd,//预期止
                    wantLevel: dataForm.wantLevel,//意向程度
                    wantHouse: wantHouse,//意向场地
                    remark: dataForm.remark,//备注
                }).then(res => {
                    this.loading = false;
                    this.$message.success(this.type + '咨询成功！');
                    this.$emit('refresh');
                    this.checkedAlert = false;
                    this.$emit('update:visible', false)
                }).catch(err => {
                    this.loading = false;
                    this.$message.error(err.msg);
                })
            },
            submitForm(formName) {

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        console.log(this.dataForm, this.checkedAlert)
                        if (this.type == '新增') {
                            this.addSubmit();
                        } else {
                            this.editSubmit();
                        }

                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            close() {
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style scoped lang="scss">
    .alerttext {
        margin-top: -30px;
        padding: 20px 70px;
        color: #666;
        font-size: 12px;
    }
</style>